import { AuiChartBase } from './AuiChartBase';
import type { AuiRendererProps } from '../../registry';

export function AuiScatterChart(props: AuiRendererProps) {
  return <AuiChartBase {...props} testId="aui-scatter-chart" />;
}
